import { render } from "./AIPopUpFields.vue?vue&type=template&id=277b735b"
import script from "./AIPopUpFields.vue?vue&type=script&lang=js"
export * from "./AIPopUpFields.vue?vue&type=script&lang=js"

import "./AIPopUpFields.vue?vue&type=style&index=0&id=277b735b&lang=css"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__